
























































































import Vue, { PropType } from 'vue';

interface Link {
  text: string;
  to?: string | Location;
  icon: 'brand' | 'booth' | 'item' | 'account';
}

interface DataType {
  isMenuActive: boolean;
}

export default Vue.extend({
  name: 'GBuyerSideNavigation',
  props: {
    mainLinks: {
      type: Array as PropType<Link[]>,
      default: () => [],
    },
    accountLinks: {
      type: Array as PropType<Link[]>,
      default: () => [],
    },
  },
  data(): DataType {
    return {
      isMenuActive: false,
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuActive = !this.isMenuActive;
    },
    handleResize() {
      if (window.innerWidth > 767 && this.isMenuActive) this.isMenuActive = false;
    },
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
});
